import { combineReducers } from 'redux'
import flight from './flight'
import hotel from './hotel'

const products = combineReducers({
  flight,
  hotel,
})

export default products
